function parseAndValidateUrl(rawUrl: string, baseForRelative?: URL): URL {
	let parsedUrl: URL;
	try {
		parsedUrl = baseForRelative
			? new URL(rawUrl, baseForRelative)
			: new URL(rawUrl);
	} catch {
		throw new Error('Invalid URL');
	}

	if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
		throw new Error('Unsupported URL protocol');
	}

	if (parsedUrl.username || parsedUrl.password) {
		throw new Error('Credentials in URL are not allowed');
	}

	return parsedUrl;
}

export function resolveTrustedUrl(
	baseUrl: string,
	targetUrl: string | URL,
): URL {
	const parsedBaseUrl = parseAndValidateUrl(baseUrl);
	// NOTE: We intentionally avoid client-side trusted-origin enforcement here.
	// Allowed origins are controlled and enforced by backend CORS/security policy.
	return parseAndValidateUrl(targetUrl.toString(), parsedBaseUrl);
}
